import TeamFilter from "components/form_components/TeamFilter";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function TeamFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Team filter">
      <TeamFilter control={control} name="teamIds" label="" />
    </StyledFilterContent>
  );
}

export default TeamFilterContent;
